import React, { useMemo, useState } from "react";
import {
  NB_DocPlaceSignModule_props,
  OptionType,
} from "../type/docplace_batch_module.types";

import { Nb_SearchFilters } from "../../../components/searchFilters/searchFilters";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import GridDocPlace from "../grid/grid.js";
import Button from "@mui/material/Button";
import debounce from "lodash.debounce";
import {
  DPwrapper,
  DPTitle,
  DPheader,
  DPbody,
  DPfooter,
  DPHeaderFilter,
  DPbodyList,
} from "../style/docplace_sign_module.styles";
import SearchDocPlace from "../../../components/search/search";
import CustomizedProgressBars from "../progressBar";
import { BaseDataTable } from "../../../components/common/BaseDataTable";
import { Title } from "../../../components/title/style";
import { colors } from "../../../components/theme";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },

  "& .MuiDialog-paper": {
    width: "762px",
    maxWidth: "762px",
  },
}));

const NbFormsModuleView: React.FC<
  NB_DocPlaceSignModule_props & { nameButton: string }
> = ({ ...props }) => {
  const [showRequest, setShowRequest] = useState(false);
  const [valueSearch, setValueSearch] = useState("");

  const searchFile = (filterSearch: string) => {
    props.onClickSearch?.(filterSearch);
  };

  const debouncedResults = useMemo(() => {
    return debounce(searchFile, 300);
  }, []);

  const handleOptionSelect = (event: OptionType) => {
    props.onClickUpload && props.onClickUpload();
  };

  const statusColor = (status: string) => {
    switch (status) {
      case "Completed":
        return "#14AE5C"; // Green
      case "In Progress":
        return "#BF6A02"; // Orange
      case "Pending":
        return "#FF5722"; // Red
      default:
        return "#000"; // Default color
    }
  };
  const columns = [
    {
      field: "name",
      flex: 1,
      headerClassName: "MuiTableHead-root",
      headerName: "Name",
      renderCell: (params: any) => {
        return (
          <div
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              fontWeight: "bold",
            }}
          >
            {params.row.name}
          </div>
        );
      },
    },
    {
      field: "pages",
      headerClassName: "MuiTableHead-root",
      headerName: "Pages",
      // minWidth: 180,
      // width: 180,
      disableColumnResizable: true,
    },
    {
      field: "status",
      headerClassName: "MuiTableHead-root",
      headerName: "Status",
      // minWidth: 180,
      // width: 180,
      disableColumnResizable: true,
      renderCell: (params: any) => {
        return (
          <div
            style={{
              width: "100%",
              lineHeight: "1.2",
              padding: "4px 0",
            }}
          >
            <div
              style={{
                width: "100%",
                whiteSpace: "normal",
                wordBreak: "break-word",
                fontWeight: 600,
                color: statusColor(params.row.status),
              }}
            >
              {params.row.status}
            </div>
          </div>
        );
      },
    },
    {
      field: "startTime",
      headerClassName: "MuiTableHead-root",
      flex: 0.7,
      headerName: "Start time",
      // minWidth: 180,
      // width: 180,
      disableColumnResizable: true,
    },
    {
      field: "endTime",
      headerClassName: "MuiTableHead-root",
      headerName: "End Time",
      // minWidth: 180,
      // width: 180,
      flex: 0.7,
      disableColumnResizable: true,
    },
    {
      field: "progress",
      headerClassName: "MuiTableHead-root",
      headerName: "Progress",
      flex: 0.7,
      // minWidth: 200,
      // width: 200,
      disableColumnResizable: true,
      renderCell: (params: any) => {
        const progress = params?.row?.progress;
        return (
          <div
            style={{
              width: "100%",
              lineHeight: "1.2",
              padding: "4px 0",
            }}
          >
            <div
              style={{
                width: "100%",
                whiteSpace: "normal",
                wordBreak: "break-word",
                fontWeight: 600,
              }}
            >
              <CustomizedProgressBars progress={progress} />
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <DPwrapper>
        <Title>{props.title}</Title>

        <DPheader style={{ marginBottom: 20 }}>
          <div style={{ float: "left", display: "none" }}>
            <Button
              onClick={() => {
                props.onClickUpload && props.onClickUpload();
              }}
              sx={{ textTransform: "none" }}
              size="small"
              color="primary"
              variant="contained"
            >
              <span>{props.nameButton}</span>
            </Button>
          </div>
          <div style={{ float: "right" }}>
            <SearchDocPlace
              callSearch={debouncedResults.bind(this)}
              clear={() => {
                // refresh("");
              }}
            />
          </div>
        </DPheader>
        {/* <DPbody style={{ padding: "0 !important" }}> */}
        {/* <DPbodyList> */}
        {/* <GridDocPlace data={props.files} option={props.onClickUpload} /> */}
        <BaseDataTable
          data={props.files || []}
          columns={columns}
          option={handleOptionSelect}
        />
        {/* </DPbodyList> */}
        {/* </DPbody> */}
      </DPwrapper>
    </>
  );
};

export default NbFormsModuleView;
